'use es6';

export const SHOULD_ASK_FOR_CONSENT = 'SHOULD_ASK_FOR_CONSENT';
export const SHOULD_NOT_ASK_FOR_CONSENT = 'SHOULD_NOT_ASK_FOR_CONSENT';
export const UNDETERMINED = 'UNDETERMINED';